export const CART_GLOBAL_VARIABLE_NAME = 'BouncieEmbeddedCart';
export const CART_ELEMENT_ID = 'bouncie-embedded-cart';

export const PERSIST_STORAGE_KEY = CART_GLOBAL_VARIABLE_NAME;

const createKey = (name) => `${CART_GLOBAL_VARIABLE_NAME}_${name}`;

export const CART_CONTAINER_ID = createKey('panel');

export const EVENT_TYPES = {
    OPEN_CART: createKey('openCart'),
    CLOSE_CART: createKey('closeCart'),
    TOGGLE_CART: createKey('toggleCart'),
    READY: createKey('ready'),
    PRICING_LOADED: createKey('pricingLoaded'),
    COOKIE_UPDATE: createKey('cookieUpdate'),
};

// TODO: only used for hardcoded obd checks. Can we move all product-specific logic to live at /catalog at minimum?
export const PRODUCT_CODES = {
    BOUNCIE_OBD: 'bouncieobd',
};
